import { createContext, useContext, type ReactNode } from 'react';
interface UseTestRecord {
  testRecord: boolean;
}

const TestRecordContext = createContext<UseTestRecord | null>(null);

export const useTestRecord = () => {
  const context = useContext(TestRecordContext);

  if (!context) {
    throw new Error('Missing test record');
  }
  return context;
};

export const TestRecordProvider = ({
  children,
  isSeekTest = false,
}: {
  children: ReactNode;
  isSeekTest?: boolean;
}) => (
  <TestRecordContext.Provider value={{ testRecord: isSeekTest }}>
    {children}
  </TestRecordContext.Provider>
);
